// extracted by mini-css-extract-plugin
export var cardTitle = "_h8-1";
export var commentBubble = "_h8-e";
export var commentForm = "_h8-a";
export var commentInput = "_h8-b";
export var commentLabel = "_h8-d";
export var commentPrompt = "_h8-9";
export var csatCard = "_h8-0";
export var feedbackSection = "_h8-7";
export var starDisabled = "_h8-6";
export var starEmpty = "_h8-5";
export var starFilled = "_h8-4";
export var starWrapper = "_h8-3";
export var starsContainer = "_h8-2";
export var submittedComment = "_h8-c";
export var thankYouText = "_h8-8";